import type { Alert, GetAlertsQuery, PatchAlertBody } from '@didaskill/domain/alerts/types';

import { HttpRepository } from '../httpRepository';

const BASE_ALERTS_URI = '/api/v1/school/alerts';

export class AlertsRepository extends HttpRepository {
  /**
   * Get all alerts.
   *
   * @param query - Query.
   * @param query.lessonId - Filter on lesson ID.
   * @param query.resourceType - Filter on resource type.
   * @param query.type - Filter on alert type.
   * @param query.limit - Limit number of results.
   * @param query.offset - Skip results.
   * @returns Object with count and alerts list.
   */
  async getAlerts(query?: GetAlertsQuery): Promise<{ count: number; alerts: Alert[] }> {
    const {
      body: { count, alerts },
    } = await this.http.get(BASE_ALERTS_URI).query(query);

    return {
      count,
      alerts,
    };
  }

  /**
   * Update alert.
   *
   * @param alertId - Id of the alert.
   * @param params.assignedTo - User assigned to handle the alert.
   * @param params.status - Status of the alert.
   * @returns Alert updated.
   */
  async updateAlert(alertId: string, params: PatchAlertBody): Promise<Alert> {
    const { body } = await this.http.patch(`${BASE_ALERTS_URI}/${alertId}`).send(params);

    return body;
  }
}
